module.exports = __webpack_public_path__ + "img/drop_white.1e8e35c2.png";